import type { Collaborator, Collaborators } from '../../common/types';
import { getUsersFromCollaborationGraph } from '../collaborators';
import {
	getPermittedUsersWithProducts,
	type PermittedUsersWithProduct,
} from '../permitted-users-with-products';

export type CollaboratorProduct = 'jira' | 'confluence' | 'jira-servicedesk' | 'loom';
export type CollaboratorsWithProducts = CollaboratorWithProducts[];
export type CollaboratorWithProducts = {
	collaborator: Collaborator;
	products: CollaboratorProduct[];
};

type GetCollaboratorsInProductsInput = {
	cloudId: string;
	products: ReadonlyArray<CollaboratorProduct>;
	userId: string;
};

export const getCollaboratorsInProducts = async ({
	cloudId,
	products,
	userId,
}: GetCollaboratorsInProductsInput): Promise<CollaboratorsWithProducts> => {
	const collaborators = await getUsersFromCollaborationGraph(
		'invitedAppShortcuts',
		cloudId,
		userId,
	);

	if (collaborators.length === 0) {
		return [];
	}
	const collabsInProducts = await getPermittedUsersWithProducts(
		products,
		cloudId,
		collaborators.map((c) => c.id),
	);

	return mapToCollaboratorsWithProducts(collaborators, collabsInProducts);
};

const mapToCollaboratorsWithProducts = (
	collaborators: Collaborators,
	usersWithProducts: PermittedUsersWithProduct<CollaboratorProduct>,
): CollaboratorsWithProducts =>
	collaborators.flatMap((collaborator) => {
		const userWithProducts = usersWithProducts[collaborator.id];
		if (!(userWithProducts && userWithProducts.length > 0)) {
			return [];
		}
		return {
			collaborator,
			products: userWithProducts as CollaboratorProduct[],
		};
	});
